document.querySelectorAll<HTMLElement>(".accordion__row").forEach((row) => {
  const header = row.querySelector<HTMLElement>(".row__header");
  if (!header) return;

  header.addEventListener("click", () => {
    row.classList.toggle("expanded");
  });
});
